"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
exports.Input = function (props) {
    var classes = __spreadArrays([
        'c-input',
        '+' + props.type
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("input", __assign({ className: classes.join(' ') }, props));
};
exports.Select = function (props) {
    var type = props.type;
    var classes = __spreadArrays([
        'c-input',
        '+select'
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("select", __assign({ className: classes.join(' ') }, props), props.children);
};
exports.TextArea = function (props) {
    var classes = __spreadArrays([
        'c-input',
        '+textarea'
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("textarea", __assign({ className: classes.join(' ') }, props));
};
//# sourceMappingURL=Input.js.map